import React from "react";

interface MediaProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  stroke?: string;
  width?: number | string;
  height?: number | string;
}

const Media: React.FC<MediaProps> = ({
  fill = "#3C3C3C",
  stroke = "none",
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.47324 15.1502C2.52324 14.1502 1.80241 13.0419 1.31074 11.8252C0.819076 10.6085 0.573242 9.35019 0.573242 8.0502C0.573242 6.7502 0.819076 5.49186 1.31074 4.2752C1.80241 3.05853 2.52324 1.9502 3.47324 0.950195L4.67324 2.1502C3.87324 2.9502 3.27324 3.87103 2.87324 4.9127C2.47324 5.95436 2.27324 7.0002 2.27324 8.0502C2.27324 9.10019 2.47324 10.146 2.87324 11.1877C3.27324 12.2294 3.87324 13.1502 4.67324 13.9502L3.47324 15.1502ZM5.87324 12.7502C5.22324 12.1002 4.72741 11.3669 4.38574 10.5502C4.04408 9.73353 3.87324 8.9002 3.87324 8.0502C3.87324 7.2002 4.04408 6.36686 4.38574 5.5502C4.72741 4.73353 5.22324 4.0002 5.87324 3.3502L7.07324 4.5502C6.57324 5.0002 6.19824 5.53353 5.94824 6.1502C5.69824 6.76686 5.57324 7.4002 5.57324 8.0502C5.57324 8.6502 5.69824 9.25853 5.94824 9.8752C6.19824 10.4919 6.57324 11.0502 7.07324 11.5502L5.87324 12.7502ZM5.57324 20.0502L8.94824 9.9252C8.68158 9.69186 8.46908 9.41686 8.31074 9.1002C8.15241 8.78353 8.07324 8.43353 8.07324 8.0502C8.07324 7.3502 8.31491 6.75853 8.79824 6.2752C9.28158 5.79186 9.87324 5.5502 10.5732 5.5502C11.2732 5.5502 11.8649 5.79186 12.3482 6.2752C12.8316 6.75853 13.0732 7.3502 13.0732 8.0502C13.0732 8.43353 12.9941 8.78353 12.8357 9.1002C12.6774 9.41686 12.4649 9.69186 12.1982 9.9252L15.5732 20.0502H13.5732L12.9232 18.0502H8.24824L7.57324 20.0502H5.57324ZM8.89824 16.0502H12.2482L10.5732 11.0502L8.89824 16.0502ZM15.2732 12.7502L14.0732 11.5502C14.5732 11.1002 14.9482 10.5669 15.1982 9.9502C15.4482 9.33353 15.5732 8.7002 15.5732 8.0502C15.5732 7.4502 15.4482 6.84186 15.1982 6.2252C14.9482 5.60853 14.5732 5.0502 14.0732 4.5502L15.2732 3.3502C15.9232 4.0002 16.4066 4.73353 16.7232 5.5502C17.0399 6.36686 17.2232 7.2002 17.2732 8.0502C17.2732 8.9002 17.1024 9.73353 16.7607 10.5502C16.4191 11.3669 15.9232 12.1002 15.2732 12.7502ZM17.6732 15.1502L16.4732 13.9502C17.2732 13.1502 17.8732 12.2294 18.2732 11.1877C18.6732 10.146 18.8732 9.10019 18.8732 8.0502C18.8732 7.0002 18.6732 5.95436 18.2732 4.9127C17.8732 3.87103 17.2732 2.9502 16.4732 2.1502L17.6732 0.950195C18.6232 1.9502 19.3441 3.05853 19.8357 4.2752C20.3274 5.49186 20.5732 6.7502 20.5732 8.0502C20.5732 9.35019 20.3399 10.6085 19.8732 11.8252C19.4066 13.0419 18.6732 14.1502 17.6732 15.1502Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
};

export default Media;
